<template>
  <section class="cta-area d-ldark-bg pt-55 pb-10">
      <div class="container">
          <div class="row">
              <div class="col-lg-4 col-md-6">
                  <div class="cta-item cta-item-d mb-30">
                      <h5 class="cta-title">Follow Us</h5>
                      <p>We make consolidating, marketing and tracking your social media website easy.</p>
                      <div class="cta-social">
                          <div class="social-icon">
                              <a href="#" class="facebook"><i class="fab fa-facebook-f"></i></a>
                              <a href="#" class="twitter"><i class="fab fa-twitter"></i></a>
                              <a href="#" class="youtube"><i class="fab fa-youtube"></i></a>
                              <a href="#" class="linkedin"><i class="fab fa-linkedin-in"></i></a>
                              <a href="#" class="rss"><i class="fas fa-rss"></i></a>
                              <a href="#" class="dribbble"><i class="fab fa-dribbble"></i></a>
                          </div>
                      </div>
                  </div>
              </div>
              <div class="col-lg-4 col-md-6">
                  <div class="cta-item mb-30">
                      <h5 class="cta-title">Sign Up To Newsletter</h5>
                      <p>Join 60.000+ subscribers and get a new discount coupon  on every Saturday.</p>
                      <div class="subscribe__form">
                          <form action="#">
                              <input type="email" placeholder="Enter your email here...">
                              <button>subscribe</button>
                          </form>
                      </div>
                  </div>
              </div>
              <div class="col-lg-4 col-md-6">
                  <div class="cta-item mb-30">
                      <h5 class="cta-title">Download App</h5>
                      <p>DukaMarket App is now available on App Store & Google Play. Get it now.</p>
                      <div class="cta-apps">
                          <div class="apps-store">
                              <a href="#"><img src="/images/brand/app_ios.png" alt=""></a>
                              <a href="#"><img src="/images/brand/app_android.png" alt=""></a>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
  </section>
</template>

<script>

</script>
